export class InvalidDateValueObject extends Error {
  static fromValue(value) {
    return new this(`Invalid value for DateValueObject: ${value}, typeof: ${typeof value}`);
  }
}
